import { render, staticRenderFns } from "./ReportisticaPresenze.vue?vue&type=template&id=da28147e"
import script from "./ReportisticaPresenze.vue?vue&type=script&lang=js"
export * from "./ReportisticaPresenze.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports